import StoresBulkIndex from '../common/stores_bulk_index';
import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import karteErrorClient from '../common/karte/error';
import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const bulkConfirmationDiv = document.getElementById('store_products_bulk_confirmation') as HTMLElement;
  if (bulkConfirmationDiv == null) {
    return;
  }

  const form = bulkConfirmationDiv.querySelector('form') as HTMLFormElement;

  type storeAttributes = { id: number, name: string };
  type resultStore = { attributes: storeAttributes };
  type resultStores = { data: Array<resultStore> };
  let minStartTime: string = '';
  let maxEndTime: string = '';

  const renderStoreBadges = () => {
    const storesDiv = bulkConfirmationDiv.querySelector('.stores') as HTMLElement;
    const storesLoading = bulkConfirmationDiv.querySelector('.stores-loading') as HTMLElement;
    const storeIds = getStoreIds();
    const client = new StoresBulkIndex();
    client.getStores(storeIds).then((data) => {
      [].forEach.call((data as resultStores).data, store => {
        const badge = document.createElement('div');
        badge.classList.add('badge');
        badge.classList.add('badge-secondary');
        const storeAttributes = (store as resultStore).attributes;
        badge.innerText = storeAttributes.name;
        storesDiv.appendChild(badge);
      });
      storesLoading.style.display = 'none';
    });
  }

  const bulkCreate = () => {
    const storeProductFormDatas = form.querySelectorAll('.store-product-form-data');
    const parallelProcessingNum = 10; // 並列処理数
    const storeProductFormDataCount = storeProductFormDatas.length
    const per = Math.ceil(storeProductFormDataCount/parallelProcessingNum);
    var uploadedData = new Array;
    var promiseArray = new Array;

    // 最も早い開始日時と、最も遅い終了日時を取得
    for (var i=0; i<storeProductFormDataCount; i++){
      let startTimeElement = storeProductFormDatas[i].querySelector(`[id="staff_store_product_bulk_form_chirashiru_store_products_${i}_start_time"]`) as HTMLInputElement
      if (startTimeElement) {
        if (minStartTime === '' || new Date(startTimeElement.value) < new Date(minStartTime)) {
          minStartTime = startTimeElement.value;
        }
      }
      let endTimeElement = storeProductFormDatas[i].querySelector(`[id="staff_store_product_bulk_form_chirashiru_store_products_${i}_end_time"]`) as HTMLInputElement
      if (endTimeElement) {
        if (maxEndTime === '' || new Date(maxEndTime) < new Date(endTimeElement.value)) {
          maxEndTime = endTimeElement.value;
        }
      }
    }

    for (var i=0; i<storeProductFormDataCount; i++){
      const breakFlag = ((i+1)%per === 0);
      const lastFileFlag = storeProductFormDataCount === (i+1);
      uploadedData.push(storeProductFormDatas[i]);
      if (breakFlag || (!breakFlag && lastFileFlag)) {
        promiseArray.push(bulkCreateInParallel(uploadedData));
        // 初期化
        uploadedData = new Array;
      }
    }
    Promise.all(promiseArray).then((datas) => {
      // 完了に変更
      form.dataset.submitting = 'done';
      // マウスを変更
      changeMouseCursor('auto');
      // 成功処理
      const errors = datas.filter(data => (data['result'] == 'error'));
      if (errors.length == 0) {
        // KARTEに登録イベントを送信
        sendKarteEvent(
          'create_content',
          'store_products',
          '単品商品を一括登録で登録しました'
        );
        // エラーがない場合
        window.location.href = '/staff/store_products/index_for_group?status=only_excel&flash_notice=商品を作成しました';
      } else {
        // エラーがある場合
        // 再度、submitできるようにする
        reEnableForm();
        alert("投稿に失敗した単品商品があります。再度、投稿してみてください。\n何度も失敗する場合、サポートチームまでお問い合わせください。");
      }
    }).catch(errors => {

      // 通信処理に失敗した場合などはこちら

      // エラーで使う変数
      const errorPath = '/staff/api/store_products/bulk_create';
      const errorMessage = '単品商品の一括登録でエラー発生';
      const el = document.querySelector<HTMLElement>('#staff_infomation');
      const staffId = el?.dataset.staffId;
      const now = el?.dataset.now;

      // エラーイベントを送信 (GA)
      if(staffId && now) {
        googleAnalyticsClient.error({
          time: now,
          path: errorPath,
          staffId: staffId,
          message: errorMessage
        });
      }

      // エラーイベントを送信 (KARTE)
      karteErrorClient.error({
        path: errorPath,
        message: errorMessage
      });

      // 完了に変更
      form.dataset.submitting = 'done';
      // マウスを変更
      changeMouseCursor('auto');
      // 再度、submitできるようにする
      reEnableForm();
      alert("投稿に失敗した単品商品があります。再度、投稿してみてください。\n何度も失敗する場合、サポートチームまでお問い合わせください。");
    });;
  }

  const bulkCreateInParallel = (storeProductFormDatasInParallel: Array<any>) => {
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    const formData = getformData(storeProductFormDatasInParallel);
    return new Promise(function(resolve, reject){
      axios
        .post('/staff/api/store_products/bulk_create', formData, {
          headers: {
            'X-CSRF-Token': token
          }
        })
        .then(response => {
          const data = response.data;
          const result = data['result'];
          const baseNames = data['data'];
          if (result == 'error') {
            // 投稿できなかったことをKARTEに通知

            // エラーで使う変数
            const message = data['message'];
            const errorPath = '/staff/api/store_products/bulk_create';
            const errorMessage = '単品商品の一括登録で投稿に失敗した単品商品が発生' + ' (' + message + ')';

            // エラーイベントを送信 (KARTE)
            karteErrorClient.error({
              path: errorPath,
              message: errorMessage
            });

            errorStoreProducts(baseNames);
          } else if (result == 'created') {
            removeHiddenInputs(baseNames);
          }
          resolve(data);
        }).catch(error => {
          // エラー処理

          // 投稿できなかったことをKARTEに通知

          // エラーで使う変数
          const message = error.message;
          const errorPath = '/staff/api/store_products/bulk_create';
          const errorMessage = '単品商品の一括登録で通信エラーが発生しました' + ' (' + message + ')';

          // エラーイベントを送信 (KARTE)
          karteErrorClient.error({
            path: errorPath,
            message: errorMessage
          });

          const inputBaseNames = new Array;
          [].forEach.call(storeProductFormDatasInParallel, storeProductFormData => {
            const inputBaseName = (storeProductFormData as HTMLElement).dataset.inputBaseName as string;
            inputBaseNames.push(inputBaseName);
          });
          errorStoreProducts(inputBaseNames);
          reject(inputBaseNames);
        });
    });
  }

  const getformData = (storeProductFormDatasInParallel: Array<any>) => {
    const originalFormData = new FormData(form);
    const returnedFormData = new FormData();
    const dataMap = Array.from((originalFormData as any).entries()); // [ [key1, value1], [key2, value2] ]
    const storeIds = getStoreIds();
    [].forEach.call(storeProductFormDatasInParallel, storeProductFormData => {
      const inputBaseName = (storeProductFormData as HTMLElement).dataset.inputBaseName as string;
      [].forEach.call(dataMap, keyValueArray => {
        const key = keyValueArray[0] as string;
        const value = keyValueArray[1] as string;
        if (key.indexOf(inputBaseName) != -1) {
          returnedFormData.append(key, value);
        }
      });
      // 店舗IDを加える
      [].forEach.call(storeIds, storeId => {
        const key = inputBaseName + '[chirashiru_store_ids][]';
        returnedFormData.append(key, storeId);
      });
    });
    // 単品商品グループのuuidを取得
    const storeProductGroupUuidInput = document.getElementById('chirashiru_store_product_group_uuid') as HTMLInputElement;
    const storeProductGroupUuid = storeProductGroupUuidInput.value;
    returnedFormData.append(
      'staff_store_product_bulk_form[chirashiru_store_product_group_uuid]',
      storeProductGroupUuid
    );
    returnedFormData.append('staff_store_product_bulk_form[min_start_time]', minStartTime);
    returnedFormData.append('staff_store_product_bulk_form[max_end_time]', maxEndTime);
    return returnedFormData;
  }

  form.addEventListener('submit', (e) => {
    // マウスを変更
    changeMouseCursor('wait');
    // 送信ボタンを変更
    const submitButton = form.querySelector('[type="submit"]') as HTMLButtonElement;
    if (submitButton != null) {
      submitButton.value = '送信中...';
      submitButton.disabled = true;
    }
    // 離脱防止処理
    window.addEventListener('beforeunload', event => {
      if (form.dataset.submitting == 'true') {
        event.preventDefault();
        event.returnValue = 'データ送信中です。\n本当に離脱しますか？';
      }
    });
    form.dataset.submitting = 'true';
    // 送信処理
    bulkCreate();
    // submitでの送信をストップ
    e.preventDefault();
    return false;
  });

  const changeMouseCursor = (cursor: string) => {
    bulkConfirmationDiv.style.cursor = cursor;
  }

  const getStoreIds = () => {
    const storesDiv = bulkConfirmationDiv.querySelector('.stores') as HTMLElement;
    const storeIdsStr = storesDiv.dataset.storeIds;
    const storeIds = String(storeIdsStr).split(',');
    return storeIds;
  }

  const removeHiddenInputs = (baseNames: Array<any>) => {
    const storeProductFormDatas = form.querySelectorAll('.store-product-form-data');
    // 処理に成功したinputsを削除する
    [].forEach.call(storeProductFormDatas, storeProductFormData => {
      const inputBaseName = (storeProductFormData as HTMLElement).dataset.inputBaseName as string;
      if (baseNames.indexOf(inputBaseName) != -1) {
        (storeProductFormData as HTMLElement).remove();
      }
    });
    // 処理に失敗した単品商品を明示的にする
    const trs = form.querySelectorAll('table tbody tr.error');
    [].forEach.call(trs, tr => {
      const inputBaseName = (tr as HTMLElement).dataset.inputBaseName as string;
      if (baseNames.indexOf(inputBaseName) != -1) {
        (tr as HTMLElement).classList.remove('error');
      }
    });
  }

  const errorStoreProducts = (baseNames: Array<any>) => {
    // 処理に失敗した単品商品を明示的にする
    const trs = form.querySelectorAll('table tbody tr');
    [].forEach.call(trs, tr => {
      const inputBaseName = (tr as HTMLElement).dataset.inputBaseName as string;
      if (baseNames.indexOf(inputBaseName) != -1) {
        (tr as HTMLElement).classList.add('error');
      }
    });
  }

  const reEnableForm = () => {
    form.dataset.submitting = '';
    // 送信ボタンを変更
    const submitButton = form.querySelector('[type="submit"]') as HTMLButtonElement;
    if (submitButton != null) {
      submitButton.value = '投稿する';
      submitButton.disabled = false;
    }
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 登録したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  renderStoreBadges();
})
